export default {
  switchAccount: "تبديل الحساب",
  login: "تسجيل الدخول",
  loginFirst: "الرجاء تسجيل الدخول",
  start: "ابدأ",
  hasHistory: "لقد أجبت بالفعل عن بعض الأسئلة.",
  loadHistory: "هل تريد الاستمرار؟",
  cancel: "لا",
  confirm: "نعم",
  contact: "اترك معلومات التواصل معك وستكون لديك فرصة للفوز بجوائز إضافية!",
  completed: "لقد أكملت الاستبيان!",
  leaveMessage:
    "اترك معلومات التواصل معك وستكون لديك فرصة للفوز بجوائز إضافية!",
  enterEmail: "البريد الإلكتروني:",
  enterPhone: "رقم الهاتف:",
  submit: "تسليم",
  leave: "مغادرة",
  submitted: "تم التسليم",
  thanks: "شكرًا لك!",
  opinion: "ما رأيك؟",
  prev: "السابق",
  next: "التالي",
  unlikely: "لا يمكن",
  likely: "بالتأكيد يمكن",
  claimYourRewards: "يمكنك استلام مكافآتك.",
  rewardSent: "تم إرسال المكافآت.",
  checkInGame: "يرجى استلامهم بداخل اللعبة.",
  copy: "نسخ",
  copied: "تم النسخ!",
  selectTips: "يرجى اختيار أفضل إجابة.",
  multipleTips: "يمكنك اختيار عدة أجوبة.",
  leastChoose: "اختر حتى xxx من الإجابات",
  maxChoose: "اختر على الأقل xxx من الإجابات.",
  mustAnswer: "يرجى الإجابة على السؤال الحالي أولاً.",
  mustWrite: "يرجى كتابة أي محتوى.",
  checkEmail: "يرجى إدخال بريد إلكتروني صالح.",
  checkPhone: "يرجى إدخال رقم هاتف صالح.",
  isAnswer: "لقد أجبت على جميع الأسئلة!",
  unStart: "الحدث غير متاح",
  end: "الحدث قد انتهى",
  server: "اختر الخادم",
  role: "اختر الشخصية",
  common: "النظام مشغول. الرجاء إعادة المحاولة لاحقًا.",
  title: "استطلاع الرأي",
  titleAward: "الاستبيان",
  leastWord: "يرجى إدخال xxx أحرف على الأقل.",
  maxWord: "تم تخطي الحد الأقصى لعدد الحروف (xxx)!",
  singleChoose: "إجابة واحدة",
  multiChoose: "متعدد الإجابات",
  matrix: "سؤال المصفوفة",
  score: "التقييم",
  textLimit: "(شخصيات xx-yyy)",
  coverGiftTitle: "أكمل الاستبيان للحصول على المكافأة",
  "-20001": "لم يتم تسجيل الدخول",
  "-20002": "معاملات مطلوبة مفقودة",
  "-20003": "الاستبيان غير موجود",
  "-20004": "تكوين الاستبيان قيد التنفيذ",
  "-20005": "تم إيقاف الاستبيان",
  "-20006": "حدث الاستبيان لم يبدأ",
  "-20007": "انتهى حدث الاستبيان",
  "-20008": "تم الرد بالفعل",
  "-20010": "فشل توزيع المكافأة",
  "-20011": "تم توزيع المكافأة بالفعل لهذا الاستبيان",
  "-20012": "لم يتم الرد بعد",
  "-20016": "معرف اللعبة غير صالح",
};
